export const AUTH_ENTRYPOINT = process.env.REACT_APP_AUTH_ENDPOINT;
export const check_login = AUTH_ENTRYPOINT + '/api/login_check';
export const refreshTokenRoute = AUTH_ENTRYPOINT + '/refreshastotoken';

export const loginCondivisioneRoute =
    AUTH_ENTRYPOINT + `/api/condivisione/login_check`;

export const getDocumentiClienteRoute = (utenteId) =>
    AUTH_ENTRYPOINT + `/documenti/${utenteId}/cliente`;


export const creaSeatsStripeRoute = (studioUuid) =>
    AUTH_ENTRYPOINT + `/api/stripe/${studioUuid}/seats`;
export const getConsulentiStudioRoute = (studioUuid) =>
    AUTH_ENTRYPOINT + `/studio/${studioUuid}/consulenti`;
export const getClientiStudioRoute = (studioUuid) =>
    AUTH_ENTRYPOINT + `/studio/${studioUuid}/clienti`;
export const studioStatisticheRoute = (studioUuid) =>
    AUTH_ENTRYPOINT + `/studio/${studioUuid}/statistiche`;
export const utenteStatisticheRoute = (studioUuid, consulenteUuid) =>
    AUTH_ENTRYPOINT +
    `/studio/${studioUuid}/statistiche/consulente/${consulenteUuid}`;


export const restoreDocumentoRoute = (documentoId) =>
    AUTH_ENTRYPOINT + `/documento/${documentoId}/ripristina`;

export const getStudiUtenteRoute = (utenteUuid) =>
    AUTH_ENTRYPOINT + `/utenti/${utenteUuid}/studi`;
export const getStudioDocumentiRoute = (studioUuid) =>
    AUTH_ENTRYPOINT + `/api/admin/studio/${studioUuid}/documenti`;
export const getAdminDocumentoRoute = (documentoUuid) =>
    AUTH_ENTRYPOINT + `/api/admin/documenti/${documentoUuid}`;
export const getAdminutentiDocumentoRoute = (documentoUuid) =>
    AUTH_ENTRYPOINT + `/api/admin/documenti/${documentoUuid}/utenti`;

export const creaStudioRoute = AUTH_ENTRYPOINT + `/api/admin/studio`;

export const acquistaFEAFirmeRoute = (studioUuid) =>
    AUTH_ENTRYPOINT + `/studio/${studioUuid}/fea`;

export const inviaEmailKopjraRoute = (kopjraId) =>
    AUTH_ENTRYPOINT + `/firme/${kopjraId}/invia_email`;

// UTENTI
export const deleteUtenteRoute = (utenteUuid) =>
    AUTH_ENTRYPOINT + `/utenti/${utenteUuid}`;

//TEMPLATE DOCUMENTO
export const getTemplateRoute = (documentoId) =>
    AUTH_ENTRYPOINT + `/templates/${documentoId}`;
export const salvaTemplateStaffRoute = AUTH_ENTRYPOINT + `/templates/staff`;
export const rimuoviTemplateRoute = (templateId) =>
    AUTH_ENTRYPOINT + `/templates/${templateId}`;
export const favoriteTemplateRoute = (utenteUuid, templateUuid) =>
    AUTH_ENTRYPOINT + `/utenti/${utenteUuid}/templates/${templateUuid}`;
export const cambiaDraftRoute = (templateId) =>
    AUTH_ENTRYPOINT + `/templates/${templateId}/cambia_draft`;
export const cambiaStatoTemplateRoute = (studioId, consulenteId, templateId) =>
    AUTH_ENTRYPOINT +
    `/studi/${studioId}/consulenti/${consulenteId}/templates/${templateId}/cambia_stato`;

// CLAUSOLE
export const clausoleBaseRoute = AUTH_ENTRYPOINT + `/clausole`;
export const rimuoviClausolaRoute = (id) => AUTH_ENTRYPOINT + `/clausole/${id}`;
export const exportClausoleRoute =
    AUTH_ENTRYPOINT + `/clausole_personali/export`;
export const importClausoleRoute = AUTH_ENTRYPOINT + `/clausole/import`;
export const rimuoviVisibilityStudioToClausolaRoute = (uuid) =>
    AUTH_ENTRYPOINT + `/clausole/${uuid}/remove_visibility`;
export const addVisibilityStudioToClausolaRoute = (uuid) =>
    AUTH_ENTRYPOINT + `/clausole/${uuid}/visibility`;

export const getStaffRoute = AUTH_ENTRYPOINT + `/staff`;
export const cediDocumentoStaff = (documentoUuid) =>
    AUTH_ENTRYPOINT + `/documenti/${documentoUuid}/staff`;

export const estendiPasswordRoute = (utenteUuid) =>
    AUTH_ENTRYPOINT + `/utenti/${utenteUuid}/estendi_forgot_time`;

// ADMIN STUDIO
export const toogleProceduraPagamentoRoute = (studioUuid) =>
    AUTH_ENTRYPOINT + `/api/admin/studi/${studioUuid}/procedura_pagamento`;
export const estendiTrialRoute = (studioUuid) =>
    AUTH_ENTRYPOINT + `/api/admin/studi/${studioUuid}/estendi_trial`;
export const rinnovaPianoRoute = (studioUuid) =>
    AUTH_ENTRYPOINT + `/api/admin/studi/${studioUuid}/rinnova`;
export const creaTrialRoute = (studioUuid) =>
    AUTH_ENTRYPOINT + `/api/admin/studi/${studioUuid}/trial`;


export const creaCategoriaRoute = `${AUTH_ENTRYPOINT}/categorie`; // POST
export const aggiornaCategoriaRoute = (categoriaUuid) =>
    `${AUTH_ENTRYPOINT}/categorie/${categoriaUuid}`; // PUT/PATCH
export const rimuoviCategoriaRoute = (categoriaUuid) =>
    `${AUTH_ENTRYPOINT}/categorie/${categoriaUuid}`; // DELETE
export const setCategorieTemplateRoute = (templateUuid) =>
    `${AUTH_ENTRYPOINT}/templates/${templateUuid}/categoria`; // POST (imposta insieme completo)
export const rimuoviAssociazioneCategoriaTemplateRoute = (templateUuid) =>
    `${AUTH_ENTRYPOINT}/templates/${templateUuid}/categoria`;
export const creaClausolaAIRoute = (studioUuid) =>
    AUTH_ENTRYPOINT + `/ai/${studioUuid}/clausole`;

// TERMS & CONDITIONS
export const termConditionBaseRoute = AUTH_ENTRYPOINT + `/termsandconditions`;

export const getTermConditionRoute = (uuid) =>
    `${termConditionBaseRoute}/${uuid}`;
export const updateTermConditionRoute = (uuid) =>
    `${termConditionBaseRoute}/${uuid}`;
export const deleteTermConditionRoute = (uuid) =>
    `${termConditionBaseRoute}/${uuid}`;
